export default __webpack_public_path__ + "static/44-fit-9e71a39ba11c54bc03d48ce8b2025910.png";